/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {
    IconClockTable,
    IconDateTimeCalendar,
    IconScheduleTable, IconSubZoneTitle,
    IconZoneTitle, MarkerTitle
} from "../../../../../components/buttons/IconButtons";
import {getDateFormat, getTimeFormat} from "../../../../../Apis/functions";
import React from "react";

const RenderExpandedRow = ({row}) => {


    return (
        <div className={"row"}>
           <div className={"col-6"}>
               <CustomGenericTittleIconDataChip
                   title={'date_time'}
                   Icon={IconDateTimeCalendar}
               />
               <div className={"gap-12px d-flex flex-column mt-12px"}>
                   <div className={"d-flex align-items-center mb-1"}>
                       <IconScheduleTable className={"mr-8px icon-color-general-950"}/>
                       {getDateFormat(row?.startDate,false)}
                   </div>
                   <div className={"d-flex align-items-center"}>
                       <IconClockTable className={"mr-8px icon-color-general-950"}/>
                       {getTimeFormat(row?.startDate)}
                   </div>
               </div>
           </div>
            <div className={"col-6"}>
               <CustomGenericTittleIconDataChip
                   title={'access_zone'}
                   Icon={MarkerTitle}
               />
               <div className={"gap-12px d-flex flex-column mt-12px"}>
                   <div className={"d-flex align-items-center mb-1"}>
                       <IconZoneTitle className={"mr-8px"}/>
                       {row?.rootFatherZoneName}
                   </div>
                   <div className={"d-flex align-items-center"}>
                       <IconSubZoneTitle className={"mr-8px"}/>
                       {row?.zoneName}
                   </div>
               </div>
           </div>
        </div>

    )

}

export default RenderExpandedRow
